export default __webpack_public_path__ + "static/home-agro-c3b3d0e23ebae8bc4b8b3be46892ff75.svg";